import React from 'react';
import { useParams } from 'react-router';
import { observer } from 'mobx-react-lite';

import { ScreenHeader } from '../../projects/components/screen-header';
import { ScreenContainer } from '../../projects/components/styled-project-components';
import { LocationBreadcrumb } from '../components/location-breadcrumb';
import { ActionBar } from '../../assets/components/action-bar';
import { FolderView } from '../../assets/components/folder-view';
import { Location } from '../../../app/entities/location';

import type { ScreenProps } from '../../projects/models/types';

import styles from './location-files.screen.module.scss';
export const LocationFilesScreen: React.FC<ScreenProps> = observer(({ step, spaceId }) => {
  const { locationId } = useParams() as { locationId: string };
  const location = Location.getOne(locationId)!;

  return (
    <>
      <ScreenHeader
        breadcrumb={<LocationBreadcrumb locationId={locationId!} />}
        stepId={step._id}
        title={step.name}
        dueDate={step.dueDate}
        startDate={step.startDate}
        handleUpdateTimeFrame={(values) => step.update(values)}
        canValidateStep={false}
      />

      <ScreenContainer className={styles['content']}>
        <FolderView stepId={step._id} folderId={location.assetsFolderId || ''} isRoot />
      </ScreenContainer>

      <ActionBar spaceId={spaceId!} projectId={step.projectId} />
    </>
  );
});
